<template>
  <div id="badminton_eventsThemeList">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <MoreThemeList
      v-if="findAnalysisItemParams"
      :axiosBaseUrl="axiosBaseUrl"
      :currThemeObj="currThemeObj"
      :currCid="currCid"
      :currSid="currSid"
      :findAnalysisItemParams="findAnalysisItemParams"
      :paramsChangeObj="paramsChangeObj"
      :curTimeZoneItem="curTimeZoneItem"
    ></MoreThemeList>
  </div>
</template>

<script>
import { https_season_eventList } from '@api/platfrom_badminton_api'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import MoreThemeList from '@components/base/theme/more_themeList.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'badminton_eventsThemeList',
  mixins: [cup_base_data_mixin],
  components: {
    MoreThemeList,
    marathon_select_opt,
  },
  props: {},
  data() {
    return {
      themeTemplateType: 34,
      findAnalysisItemParams: null,
      paramsChangeObj: {
        type: '',
        num: 0,
      },
      currStageEvent: '',
      eventArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'event',
            title: '组别',
            origin_keyVal: ['eventId', 'eventName'], // 源数据list [唯一id, 需要展示文字]
            dataName: 'eventArr', //this下面的存储该数据list字段名
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
    }
  },
  created() {
    if (this.currGroup) {
      this.init()
    }
  },
  mounted() {},
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      const query = this.$route.query
      this.renderThemeList = null
      await this.getStageEvent()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'badminton',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: this.currStageEvent,
        pid: 0,
        mid: 0,
      }
      let { num } = this.paramsChangeObj
      this.paramsChangeObj = {
        type: 'reset',
        num: num + 1,
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt 11:',
            config.type,
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    async changeSelect(data) {
      console.debug('changeSelect:', data)
      let valPathArr = []
      let val = data.val
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'event') {
            this.currStageEvent = valPathArr[1]
            this.makeAnalysisItemParams(this.themeTemplateType)
          } else {
          }
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    async getStageEvent() {
      await https_season_eventList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.eventArr = res.data && res.data.length > 0 ? res.data : []
            if (this.eventArr && this.eventArr.length > 0) {
              this.computedSelectOpt(this.selectOptData.configArr)
              this.currStageEvent = this.eventArr[0].eventId
              this.makeAnalysisItemParams(this.themeTemplateType)
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#badminton_eventsThemeList {
  width: 100%;
  height: auto;
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
  }
  .themeList_container {
    padding: 1.388vw 0 2.083vw 0;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  }
}
</style>
